export default __webpack_public_path__ + "assets/models/c7e47ebabdd698b52dce92e8f4e66b73.glb";